import { getDateObj, getDateString } from '../../Services/Functions'
import { cap } from '../../State'
import { translations } from '../../translations'
import { Flex } from './Flex'
import { Input } from './Input'

const language = cap.language.state || 'IT'
const t = translations[language]

export const DateSelect = ({
  date: [selectedDate, setSelectedDate],
  style = {},
  minDate,
  maxDate,
  label = t.date
}) => {
  const changeDate = (offset) => {
    const date = getDateObj(selectedDate)
    setSelectedDate(getDateString(new Date(date.setDate(date.getDate() + offset))))
  }

  return (
    <div
      className="date-select"
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        ...style
      }}
    >
      {label ? (
        <label
          style={{
            fontSize: 'var(--font-size-sm)',
            fontWeight: 600,
            color: 'var(--ink-600)',
            marginBottom: 4,
            paddingLeft: 46
          }}
        >
          {label}
        </label>
      ) : null}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          type="button"
          className="nbtn nbtn--icon"
          aria-label={t.giornoPrecedente}
          onClick={() => changeDate(-1)}
          style={{ background: 'transparent', flexShrink: 0 }}
        >
          <i className="pi pi-chevron-left" style={{ fontSize: 14 }} />
        </button>
        <div className="nora-date-field date-select__field" style={{ width: 200, flexShrink: 0 }}>
          <Input
            {...{ minDate, maxDate }}
            value={getDateObj(selectedDate)}
            date
            showIcon
            style={{ width: '100%', height: 40 }}
            id="date"
            onChange={({ date }) => setSelectedDate(getDateString(date))}
          />
        </div>
        <button
          type="button"
          className="nbtn nbtn--icon"
          aria-label={t.giornoSuccessivo}
          onClick={() => changeDate(1)}
          style={{ background: 'transparent', flexShrink: 0 }}
        >
          <i className="pi pi-chevron-right" style={{ fontSize: 14 }} />
        </button>
      </div>
    </div>
  )
}

export const DateSelectRange = ({
  startDate: [selectedStartDate, setSelectedStartDate],
  endDate: [selectedEndDate, setSelectedEndDate],
  style = {},
  startLabel = t.dataDa,
  endLabel = t.dataA
}) => (
  <Flex row style={{ gap: 20, ...style }}>
    <DateSelect date={[selectedStartDate, setSelectedStartDate]} label={startLabel} />
    <DateSelect date={[selectedEndDate, setSelectedEndDate]} label={endLabel} />
  </Flex>
)
